export default function () {
  return {
    tickets: [],
    ticket: {}
  }
}
